import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";
import DashboardKpi from "./Dashboard/DashboardKpi";
import { helper } from "lib/helper";
import { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import DashboardGraphs from "./Dashboard/GraphComp";

const Header = () => {
  const [driverCount, setDriverCount] = useState(0);
  const [supportCount, setSupportCount] = useState(0);
  const [userCount, setUserCount] = useState(0);
  
  const totalRides = helper.generateRandomNumber();

  const [dashboardData , setDashBoardData] = useState({
    buddies: helper.generateRandomNumber(totalRides),
    listings: helper.generateRandomNumber(totalRides),
    bookings: helper.generateRandomNumber(totalRides),
    // users: helper.generateRandomNumber(totalRides),
    experienceCategories: helper.generateRandomNumber(totalRides),
    tickets: helper.generateRandomNumber(totalRides),
  });


  const config = {
    type: "doughnut",
    data: {
      labels: ["Red", "Blue"],
      datasets: [
        {
          label: "# of Votes",
          data: [12, 19],
          backgroundColor: [
            "rgba(255, 99, 132, 0.6)",
            "rgba(54, 162, 235, 0.6)",
            "rgba(255, 206, 86, 0.6)",
          ],
          borderColor: [
            "rgba(255, 99, 132, 1)",
            "rgba(54, 162, 235, 1)",
            "rgba(255, 206, 86, 1)",
          ],
          borderWidth: 1,
        },
      ],
    },
  };

  useEffect(() => {
    // getDashboardKpi();
  }, []);

  return (
    <>
      <div className="header pb-8 pt-5 pt-md-6">
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <h3>Bookings</h3>
            <Row>
              <DashboardKpi
                kpiTitle="Total Bookings"
                kpiValue={totalRides}
                kpiIcon="fa-solid fa-user"
                iconBakgroundColor="bg-primary" // Changed to primary color for users
                navigateUrl="/admin/users"
              />
              <DashboardKpi
                kpiTitle="Cancelled Bookings"
                kpiValue={dashboardData.buddies}
                kpiIcon="fa-solid fa-user-tie"
                iconBakgroundColor="bg-success" // Success color for buddies
                navigateUrl="/admin/bookings"
              />
              <DashboardKpi
                kpiTitle="Completed Bookings"
                kpiValue={dashboardData.listings}
                kpiIcon="fa-solid fa-list"
                iconBakgroundColor="bg-warning" // Warning color for listings
                navigateUrl="/admin/listings"
              />
              <DashboardKpi
                kpiTitle="Conversion Rate"
                kpiValue={dashboardData.bookings}
                kpiIcon="fa-solid fa-book"
                iconBakgroundColor="bg-info" // Info color for bookings
                navigateUrl="/admin/bookings"
              />
            </Row>
            <h3 className="mt-4">Revenue</h3>
            <Row className="">
              <DashboardKpi
                kpiTitle="Total Revenue"
                kpiValue={dashboardData.experienceCategories}
                kpiIcon="fa-solid fa-chess-board"
                iconBakgroundColor="bg-danger" // Danger color for categories
                navigateUrl="/admin/experience-categories"
              />
              <DashboardKpi
                kpiTitle="Revenue Growth"
                kpiValue={dashboardData.tickets}
                kpiIcon="fa-solid fa-ticket-alt"
                iconBakgroundColor="bg-dark" // Secondary color for tickets
                navigateUrl="/admin/support"
              />
              <DashboardKpi
                kpiTitle="Average Revenue/User"
                kpiValue={dashboardData.tickets}
                kpiIcon="fa-solid fa-ticket-alt"
                iconBakgroundColor="bg-dark" // Secondary color for tickets
                navigateUrl="/admin/support"
              />
            </Row>
            <h3 className="mt-4">User Growth</h3>
            <Row >
              <DashboardKpi
                kpiTitle="New SignUps"
                kpiValue={dashboardData.experienceCategories}
                kpiIcon="fa-solid fa-chess-board"
                iconBakgroundColor="bg-danger" // Danger color for categories
                navigateUrl="/admin/experience-categories"
              />
              <DashboardKpi
                kpiTitle="Active Users"
                kpiValue={dashboardData.tickets}
                kpiIcon="fa-solid fa-ticket-alt"
                iconBakgroundColor="bg-dark" // Secondary color for tickets
                navigateUrl="/admin/support"
              />
              <DashboardKpi
                kpiTitle="Retention Rate"
                kpiValue={dashboardData.tickets}
                kpiIcon="fa-solid fa-ticket-alt"
                iconBakgroundColor="bg-dark" // Secondary color for tickets
                navigateUrl="/admin/support"
              />
              </Row>

            <DashboardGraphs listingCount={dashboardData.listings} buddiesCount={dashboardData.buddies} userCount={totalRides} bookingCount={dashboardData.buddies} />
          </div>
        </Container>
      </div>
    </>
  );
};

export default Header;
